import { Component, OnInit } from "@angular/core";
import { DefaultPageComponent } from "../../shared/page/default-page.component";
import { JourneyService } from "../../shared/service/journey/journey.service";
import { BackNativeService } from "../../shared/service/comunicator-native/back-native/back-native";
import { NavController } from "@ionic/angular";
import { ReturnNativeService } from "../../shared/service/comunicator-native/return-native/return-native";
import { Title } from "@angular/platform-browser";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import {
  CustodiaRemunerada,
  CustodiaRemuneradaFaq,
  CustodiaRemuneradaTerm,
} from "../../shared/service/custodia-remunerada/model/custodia-remunerada.model";
import { DataOrigin } from "../../shared/model/DataOrigin";
import { CustordiaRemuneradaFactoryService } from "../../shared/service/custodia-remunerada/custodia-remunerada-factory.service";
import { LocalStorageService } from "../../shared/service/storage/storage.service";
import { UserSignupFactoryService } from "../../shared/service/user-signup/user-signup-factory-service";
import { UserInvestorParseData } from "../../shared/service/journey/tracks/cadastro-investidor-v2/util/user-investor-parse-data";
import { IncomeWealthService } from "../../income-wealth/service/income-wealth.service";
import { TrackTypes } from "../../../app/shared/service/journey/tracks/model/track-types";
import { AnalyticsPageModel } from "../../../app/shared/model/analyticsPage";
import { AnalyticsGA4PagesModel } from "../../../app/shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { AnalyticsGA4PageService } from "../../../app/shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { DomainOrigin } from "../../shared/service/user-signup/model/domain-origin";
import { MOCK_RLP_DATA } from "./model/mock-data-rlp";
import { MOCK_DATA_CUSTODIA_TERMO } from "./model/mock-data-custodia-termo";
import { MOCK_DATA_CUSTODIA_FAQ } from "./model/mock-data-custodia-faq";


@Component({
  selector: "app-rlp",
  templateUrl: "./rlp.component.html",
  styleUrls: ["./rlp.component.scss"],
})
export class RlpComponent extends DefaultPageComponent implements OnInit {
  labelButton = "Continuar";
  approved = false;
  voicePagePost = false;
  loadingVerify = false;
  headerId = "rlp";
  titlePage = "Oferta de serviços";
  ariaLabelPage = true;
  sentData = false;
  labelBtnBack = "Voltar";
  showContinueButtom: boolean | unknown = false;
  formCustodia = new FormGroup({
    custodia: new FormControl(""),
  });
  formRlp = new FormGroup({
    rlp: new FormControl(""),
  });
  isLoading = true;
  loading = true;
  textareaLabel = "Aceito ativar o serviço";
  idLabel = "page-rlp";
  ariaLabelLink = "Abrir termo";
  idLink = "abrir-termo-rlp";
  rlpCheck: boolean | unknown = false;
  custodiaCheck: boolean | unknown = false;
  custodiaRemunerada: CustodiaRemunerada;
  dataDetail: CustodiaRemuneradaTerm;
  dataDetailFaq: any;
  dataOrigin = DataOrigin.Mobile;
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  showConditionalShimmer = true;
  MOCK_RLP_DATA: typeof MOCK_RLP_DATA;
  MOCK_DATA_CUSTODIA_TERMO: typeof MOCK_DATA_CUSTODIA_TERMO;
  MOCK_DATA_CUSTODIA_FAQ: typeof MOCK_DATA_CUSTODIA_FAQ;
  focusId: string;

  constructor(
    public router: NavController,
    private formBuilder: FormBuilder,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public returnNativeService: ReturnNativeService,
    private title: Title,
    private termsFactoryService: CustordiaRemuneradaFactoryService,
    private storage: LocalStorageService,
    private userSignupFactoryService: UserSignupFactoryService,
    private incomeWealthService: IncomeWealthService,
    private analyticsGA4PageService: AnalyticsGA4PageService
    
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPageGA4();

    // try {
    //   this.getCustodiaRemunerada();
    // } catch (error) {
    //   console.log('Error initialize charon');
    // }
  }

  ngOnInit() {
    this.setTitle();
    this.createRlpForm();
    this.createCustodiaForm();
    this.showConditionalShimmer = false;
    this.headerFocus();
  }

  ionViewWillEnter() {
    this.focusPageWithDetail(this.focusId);
    this.sendTrackGA4LoadPage();
  }

  // Analytics GA4
  // Analytics GA4

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathOfertaServicos,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4OpenTerm() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameClick,
      custom_path: this.analyticsPageGA4.customPathOfertaServicos,
      implementation_team: this.analyticsPageGA4.implementationTeam,
      detail: "custodia:abrir-termo"
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4CustodiaFaq() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameClick,
      custom_path: this.analyticsPageGA4.customPathOfertaServicos,
      implementation_team: this.analyticsPageGA4.implementationTeam,
      detail: "custodia-faq"
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4RlpFaq() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameClick,
      custom_path: this.analyticsPageGA4.customPathOfertaServicos,
      implementation_team: this.analyticsPageGA4.implementationTeam,
      detail: "rlp-faq"
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4CheckCustodia() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameClick,
      custom_path: this.analyticsPageGA4.customPathOfertaServicos,
      implementation_team: this.analyticsPageGA4.implementationTeam,
      detail: "aceitar-termo:custodia-remunerada"
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4CheckRlp() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameClick,
      custom_path: this.analyticsPageGA4.customPathOfertaServicos,
      implementation_team: this.analyticsPageGA4.implementationTeam,
      detail: "aceitar-termo:rlp"
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }


  // Analytics GA4
  // Analytics GA4


  createCustodiaForm() {
    this.formCustodia = this.formBuilder.group({
      custodia: this.formBuilder.control(""),
    });
    this.formCustodia.get("custodia").valueChanges.subscribe((x: boolean | unknown) => {
      this.custodiaCheck = x;
    });
  }

  createRlpForm() {
    this.formRlp = this.formBuilder.group({
      rlp: this.formBuilder.control(""),
    });
    this.formRlp.get("rlp").valueChanges.subscribe((x) => {
      this.rlpCheck = x;
    });
  }

  sendUserData() {
      const initialData = {
          incomeEquity: {
              ...this.incomeWealthService.getInitialDataTaxResidence(),
          },
      };  
      const userSignUpData = UserInvestorParseData.formatToUserSignup(
          this.journeyService.registratioJourney.data,
          initialData
      );  
      this.labelButton = "Validando iToken...";
      this.loadingVerify = true;
  
      const id_investidor = this.journeyService.registratioJourney.data.idInvestor;
  
      const appIos = document.querySelector(".plt-ios") ? true : false;
  
      if (!appIos) {
          this.showVoicePagePost();
      }
  
      if (!this.sentData) {
          this.sentData = true;
  
          this.userSignupFactoryService
              .getService(DomainOrigin.Registration)
              .postUserSignup(userSignUpData, id_investidor)
              .then((data: any) => {
  
                  if (
                      data?.data?.code === 200 ||
                      data?.data?.code === 202 ||
                      data?.data?.success === true
                  ) {
                      setTimeout(() => {
                          this.setStateSuccess();
                          setTimeout(() => {
                              this.redirectToEndPage();
                          }, 2000);
                      }, 3000);
                  } else {
                      this.setStateRetry();
                      this.sentData = false;
                  }
              })
              .catch((error) => {
                  console.error("Error during backend call:", error);
                  this.setStateRetry();
                  this.sentData = false;
              });
      } else {
          console.log("Data has already been sent, skipping...");
      }
  }

  setStateRetry() {
    this.labelButton = "Tentar novamente";
    this.loadingVerify = false;
    this.approved = false;
    this.showVoicePagePost();
  }

  setStateSuccess() {
    this.labelButton = "Tudo certo!";
    this.approved = true;
    this.loadingVerify = false;
    this.showVoicePagePost();
  }

  showVoicePagePost() {
    this.voicePagePost = true;
    setTimeout(() => (this.voicePagePost = false), 100);
  }

  redirectToEndPage() {
    this.setDataAnalysis();
    this.router.navigateForward(["data-analysis"]);
  }

  setDataAnalysis() {
    let dataAnalisys = null;
    const journey = this.journeyService.journey;
    const name =
      this.journeyService.registratioJourney.data?.profileData?.name ===
        undefined ||
      this.journeyService.registratioJourney.data?.profileData?.name === ""
        ? this.journeyService.registratioJourney.data.personalData.name
        : this.journeyService.registratioJourney.data?.profileData?.name;

    const setJourneyBasic = [
      TrackTypes.BASIC_V2,
      TrackTypes.BASIC_PERSONAL_V2,
      TrackTypes.BASIC_MARITAL_V2,
      TrackTypes.BASIC_INCOME_V2,
      TrackTypes.BASIC_ADDRESS_V2,
      TrackTypes.BASIC_PROFILE_V2,
      TrackTypes.BASIC_PROFESSIONAL_V2,
    ];
    const setJourneyUpdate = [
      TrackTypes.UPDATE_REGISTRATION,
      TrackTypes.UPDATE_ADDRESS,
      TrackTypes.UPDATE_INCOME,
      TrackTypes.UPDATE_INCOME_CONTA_ION,
      TrackTypes.UPDATE_MARITAL,
      TrackTypes.UPDATE_PROFESSIONAL,
      TrackTypes.UPDATE_PROFILE,
    ];

    const currentJourneyBasic = setJourneyBasic.find((x) => x === journey);
    const currentJourneyUpdate = setJourneyUpdate.find((x) => x === journey);

    const analyticsPage = {
      pageName: this.analyticsPage?.dataAnalysisStatus,
      action: this.analyticsPage?.action,
      dataAnalysisStatusEvent: this.analyticsPage?.dataAnalysisStatusEvent,
      dataAnalysisStatusLabel: this.analyticsPage?.dataAnalysisStatusLabel,
    };

    const analyticsPageGA4 = {
      paramDefautl: {
        event_name: this.analyticsPageGA4.eventNameScreenView,
        custom_path: this.analyticsPageGA4.customPathTelaSucesso,
        implementation_team: this.analyticsPageGA4.implementationTeam,
      },
    };

    switch (journey) {
      case currentJourneyBasic:
        dataAnalisys = {
          titleContent: `${name}, seus dados foram enviados para análise.`,
          description: `<p>Em alguns minutos*, você poderá investir na bolsa.
      Enquanto isso, aproveite para navegar pelo app e conhecer mais o íon Itaú.</p>
      <p>Caso seu cadastro não seja concluído com sucesso, você receberá uma notificação
      com as instruções para regularizá-lo.</p><p>*Aplicável para dias úteis.</p>`,
          icon: "../../../assets/images/svg/new-data-analysis-vector.svg",
          analyticsPage,
          analyticsPageGA4,
          likert: true,
          nomeJornada: "ION - JORNADA CADASTRO INVESTIDOR",
          navegJornada: "MENU > COMPLETE SEU CADASTRO",
        };
        return this.storage.set("data-analisys-basic", dataAnalisys);
      case currentJourneyUpdate:
        dataAnalisys = {
          titleContent: `${name}, seus dados estão em análise.`,
          description: `<p>Em alguns minutos*, você poderá investir na bolsa. Enquanto isso, aproveite para navegar pelo app e
        conhecer mais o íon Itaú.</p><p>Caso seu cadastro não seja concluído com sucesso, você receberá uma notificação com as instruções
        para regularizá-lo.</p><p>*Aplicável para dias úteis.</p>`,
          icon: "../../../assets/images/svg/new-data-analysis-vector.svg",
          analyticsPage,
          analyticsPageGA4,
          backNative: true,
        };
        return this.storage.set("data-analisys", dataAnalisys);
      default:
        return "";
    }
  }

  clickNext() {
    if (this.custodiaCheck) {
      this.sendTrackGA4CheckCustodia();
    }
    if (this.rlpCheck) {
      this.sendTrackGA4CheckRlp();
    }
    this.journeyService.registratioJourney.data.servicos = {};
    this.journeyService.registratioJourney.data.servicos.ativacao_custodia_remunerada = this.custodiaCheck;
    this.journeyService.registratioJourney.data.servicos.ativacao_rlp = this.rlpCheck;
    this.sendUserData();
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  getCustodiaRemunerada() {
    this.termsFactoryService
      .getService(this.dataOrigin)
      .getCustodiaRemunerada()
      .subscribe({
        next: (term: CustodiaRemunerada) => {
          this.custodiaRemunerada = term;
          this.loadContentCustodiaRemunerada();
          // console.log(term)
        },
        error(err) {
          console.log(err);
        },
        complete: () => {
          this.isLoading = false;
          // console.log("Completed");
        },
      });
  }

  backPage() {
    // this.back();
    this.router.navigateForward(["terms"]);
  }

  getPageId(): string {
    return this.headerId;
  }

  openDetail() {
    this.sendTrackGA4OpenTerm();
    this.router.navigateForward("details", {
      state: {
        data: {
          ...MOCK_DATA_CUSTODIA_TERMO,
        },
      },
    });
  }

  openDetailFaq() {
    this.sendTrackGA4CustodiaFaq();
    this.router.navigateForward("details-faq", {
      state: {
        data: {
          ...MOCK_DATA_CUSTODIA_FAQ,
        },
      },
    });
  }

  openFaq() {
    this.sendTrackGA4RlpFaq();
    this.router.navigateForward("details", {
      state: {
        data: {
          ...MOCK_RLP_DATA,
        },
      },
    });
  }

  loadContentCustodiaRemunerada() {
    this.dataDetail = {
      ...this.custodiaRemunerada.termo,
    };
    this.dataDetailFaq = {
      index: this.idLink,
      faq: this.custodiaRemunerada.faq,
    };
    this.loading = false;
  }
}
